import {components, pages} from "../config";

const contentModules: any = {
  [pages.aboutUs]: {
    en: () => import('./about-us-en'),
    ar: () => import('./about-us-ar')
  },
  [pages.contactUs]: {
    en: () => import('./contact-details-en'),
    ar: () => import('./contact-details-ar')
  },
  [pages.services]: {
    en: () => import('./our-services-en'),
    ar: () => import('./our-services-ar')
  },
  [pages.leasingAndRental]: {
    en: () => import('./leasing-and-rental-en'),
    ar: () => import('./leasing-and-rental-ar'),
    // ar: () => import('./our-service-ar')
  },
  [pages.assetsAndPropertyManagement]: {
    en: () => import('./assets-and-property-management-en'),
    ar: () => import('./assets-and-property-management-ar'),
  },
  [pages.b2bPage]: {
    en: () => import('./b2b-page-en'),
    ar: () => import('./b2b-page-ar'),
  },
  [pages.careers]: {
    en: () => import('./careers-en'),
    ar: () => import('./careers-ar'),
  },
  [pages.ourTeam]: {
    en: () => import('./our-team-en'),
    ar: () => import('./our-team-ar'),
  },
  [components.navigation]: {
    en: () => import('./navigation-en'),
    ar: () => import('./navigation-ar'),
  },
  [components.commonTexts]: {
    en: () => import('./common-text-en'),
    ar: () => import('./common-text-ar'),
  },
  [components.forms]: {
    en: () => import('./form-en'),
    ar: () => import('./form-ar'),
  },
  [components.filters]: {
    en: () => import('./filter-labels-en'),
    ar: () => import('./filter-labels-ar'),
  }
};

export async function loadContent(page: string, language: string): Promise<any> {
  try {
    if (contentModules[page] && contentModules[page][language]) {
      return await contentModules[page][language]();
    } else {
      console.log(`Content for page: ${page} and language: ${language} not found.`);
    }
  } catch (error) {
    throw error;
  }
}
